import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import './css/style.css';
import 'font-awesome/css/font-awesome.min.css';
import { Redirect, Route, Switch } from 'react-router-dom';
import Navigation from '../commen/Navigation/MainNavigation';
import './App.css';
import ScrollToTop from './../shared/utils/ScrollToTop';
import GlobalState from './GlobalState';
import Home from './Home';
import Who from './Who';
import NotFound from './../commen/NotFound';
import Persons from '../personnel/persons';
import PersonInfo from '../personnel/personInfo';
import Where from './Where';
import Places from '../places/places';
import PlaceInfo from '../places/placeInfo';
import What from './What';
import EditInformationUser from '../user/EditInformation';
import Orders from './../user/Orders';
import Wallet from '../user/wallet';
import About from './About';
import Footer from './../commen/Footer';
import Shop from './Shop';
import Products from '../products/products';
import ShoppingCart from '../user/ShoppingCart';
import SuccessfullOrder from '../user/SuccessOrder';
import POrders from '../user/POrders';


function App() {
  return (
    <div className="App rtl">
      <GlobalState>
        <Navigation />
        <ScrollToTop />
        <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/who' exact component={Who} />
        <Route path='/who/person' exact component={Persons} />
        <Route path='/who/person/info/:pid' exact component={PersonInfo} />
        <Route path='/where' exact component={Where} />
        <Route path='/where/places' exact component={Places} />
        <Route path='/where/places/info/:pid' exact component={PlaceInfo} />
        <Route path='/shop' exact component={Shop} />
        <Route path='/shop/products' exact component={Products} />
        <Route path='/what' exact component={What} />
        <Route path='/shoppingcart' exact  component={ShoppingCart} />
        <Route path='/order2-successfull' exact  component={SuccessfullOrder} />
        <Route path='/product-orders' exact  component={POrders} />
        <Route path='/orders' exact  component={Orders} />
        <Route path='/wallet' exact  component={Wallet} />
        <Route path='/edituser' exact  component={EditInformationUser} />
        <Route path='/about' exact  component={About} />
        <Route path='/not-found' exact component={NotFound} />
				<Redirect to="/not-found" />
        </Switch>
        <Footer />
      </GlobalState>
    </div>
  );
}

export default App;
